import { gql } from "@apollo/client";
import { entitlementFields } from "./fragments";

export const GET_PLAYBACK = gql`
  ${entitlementFields}
  query PlaybackAuth($id: Int, $vuid: String, $sessionId: String, $fl: Int) {
    playbackAuth(id: $id, vuid: $vuid, sessionId: $sessionId, fl: $fl) {
      media {
        media_id
        uuid
        ovp_id
        ovp_video_id
        thumbnail_tile_urls
      }
      rule {
        playback_rule_id
        enable_seek_flag
        enable_cromecst_flag
        enable_airplay_flag
        enable_mirroring_flag
        enable_external_monitor_flag
        enable_catchup_flag
        enable_start_over_flag
        enable_pause_flag
        enable_background_play_flag
        enable_screen_capture_flag
        enable_playback_rate_change_flag
        enable_offline_play_flag
        maximum_bitrate
        minimum_bitrate
      }
      playback_session_id
      log_params
      resumePoint
      error {
        type
        message
        code
      }
      entitlements {
        ...entitlementFields
      }
    }
  }
`;

export const PLAYBACK_SESSION_OPEN_MUTATION = gql`
  mutation PlaybackSessionOpen($videoId: String, $sessionId: String) {
    playbackSessionOpen(videoId: $videoId, sessionId: $sessionId) {
      media
      error {
        type
        message
        code
      }
    }
  }
`;

export const PLAYBACK_SESSION_CHECK_MUTATION = gql`
  mutation PlaybackSessionCheck($sessionId: String) {
    playbackSessionCheck(sessionId: $sessionId) {
      result
    }
  }
`;

export const PLAYBACK_SESSION_CLOSE_MUTATION = gql`
  mutation PlaybackSessionClose($sessionId: String) {
    playbackSessionClose(sessionId: $sessionId) {
      result
    }
  }
`;
